// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline {
  list-style: none;
  display: flex;
  gap: 4px;
  padding: 16px 14px;
  margin-bottom: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-xs);
  overflow-x: auto;
}

.timeline-step {
  position: relative;
  flex: 1 1;
  min-width: 92px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  text-align: center;
}

.timeline-step::before {
  content: '';
  position: absolute;
  top: 12px;
  left: 0;
  right: 50%;
  height: 2px;
  background: var(--border);
}

.timeline-step::after {
  content: '';
  position: absolute;
  top: 12px;
  left: 50%;
  right: 0;
  height: 2px;
  background: var(--border);
}

.timeline-step:first-child::before,
.timeline-step:last-child::after {
  display: none;
}

.timeline-done::before,
.timeline-done::after {
  background: var(--brand);
}

.timeline-dot {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--surface);
  border: 2px solid var(--border);
  color: var(--muted2);
  font-family: var(--font-display);
  font-size: 0.72rem;
  font-weight: 700;
}

.timeline-done .timeline-dot {
  background: var(--brand);
  border-color: var(--brand);
  color: #fff;
}

.timeline-now .timeline-dot {
  border-color: var(--brand);
  color: var(--brand);
  box-shadow: 0 0 0 4px var(--brand-100);
}

.timeline-label {
  font-size: 0.72rem;
  line-height: 1.35;
  color: var(--muted);
}

.timeline-done .timeline-label,
.timeline-now .timeline-label {
  color: var(--text-soft);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/OrderTimeline.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".timeline {\n  list-style: none;\n  display: flex;\n  gap: 4px;\n  padding: 16px 14px;\n  margin-bottom: 18px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-xs);\n  overflow-x: auto;\n}\n\n.timeline-step {\n  position: relative;\n  flex: 1;\n  min-width: 92px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 7px;\n  text-align: center;\n}\n\n.timeline-step::before {\n  content: '';\n  position: absolute;\n  top: 12px;\n  left: 0;\n  right: 50%;\n  height: 2px;\n  background: var(--border);\n}\n\n.timeline-step::after {\n  content: '';\n  position: absolute;\n  top: 12px;\n  left: 50%;\n  right: 0;\n  height: 2px;\n  background: var(--border);\n}\n\n.timeline-step:first-child::before,\n.timeline-step:last-child::after {\n  display: none;\n}\n\n.timeline-done::before,\n.timeline-done::after {\n  background: var(--brand);\n}\n\n.timeline-dot {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: var(--surface);\n  border: 2px solid var(--border);\n  color: var(--muted2);\n  font-family: var(--font-display);\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.timeline-done .timeline-dot {\n  background: var(--brand);\n  border-color: var(--brand);\n  color: #fff;\n}\n\n.timeline-now .timeline-dot {\n  border-color: var(--brand);\n  color: var(--brand);\n  box-shadow: 0 0 0 4px var(--brand-100);\n}\n\n.timeline-label {\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: var(--muted);\n}\n\n.timeline-done .timeline-label,\n.timeline-now .timeline-label {\n  color: var(--text-soft);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
